import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { _ } from "src/services";
import { Modals, ModalsAction, ProfileData } from "src/store";
import { Modal } from "./modal";

export const FavoritesNoSportModal: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const user: ProfileData = useSelector((state: any) => state.ProfileDataState);

    const sport = user.favorites.list.find((x) => x.itemType === "Sport");

    //#end region

    //region methods

    const onClose = useCallback(() => {
        dispatch(ModalsAction.hideFavoritesNoSport());

    }, [dispatch]);

    const onAddSports = () => {
        onClose();
        sport && dispatch(ModalsAction.showFavorites(sport));
    };

    //#end region

    //#region effects

    useEffect(() => {

        if (!sport) onClose();

    }, [sport, onClose]);

    //#end region


    return (
        <Modal title={sport?.title} lg show={modals.favoritesNoSport} onClose={onClose} className="modal-component--favorites">
            <div className="content text-center">
                <div className="flex-1 d-flex flex-column justify-content-center align-items-center py-3">
                    <img className="empty-icon" alt="" src={sport?.emptyIcon} />
                    <h3 className="empty-message py-4" style={{ maxWidth: 300 }}>{sport?._texts.emptyMessage}</h3>
                    <div>
                        <button onClick={onAddSports} className="w-100 btn focusable btn-submit">{_("addFavoriteSports")}</button>
                    </div>
                </div>
            </div>
        </Modal>
    );

};